import { Component, OnInit } from '@angular/core';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from "../../../app.component";

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnInit {

  public baseUrl = myGlobals.baseFileUrl;

  imageGallery: any = [];

  constructor(
    private landingService: LandingServiceService
  ) { }

  ngOnInit(): void {
    this.baseUrl = this.baseUrl + "/homepage/image_gallery";
    this.landingService.getImageGallery().subscribe(data=>this.setImageGallery(data));
  }

  setImageGallery(data) {
    // console.log(data);
    this.imageGallery = data['Galleries'];
    // console.log(this.imageGallery);
  }

}
